<template>
  <div class="pa-3 mb-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow pb-3">
          <v-card-title primary-title>
            <div class="text-h5">FAQS</div>
            <v-spacer></v-spacer>
            <v-div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItem()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click.stop="editItem(null)">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Inserisci</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip> 
            </v-div>        
          </v-card-title>
          <!--
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>-->
            <div class="mx-4">
              <v-data-table
                dense
                fixed-header
                :headers="headers"
                :items="items||[]"
                hide-default-footer
                :items-per-page=500
                :item-class="itemClass"
                :loading="loading"
                no-data-text="Nessun dato presente in archivio"
                no-results-text="Nessun Risultato estratto"
                loading-text="Consultazione archivio: attendi..."
              >
                  <!--
                    <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                          <v-icon color="success">mdi-book-edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Modifica</span>
                    </v-tooltip>                        
                  </template>
                  
                  <template v-slot:[`item.A`]="{ item }">
                    <v-tooltip top max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                          <v-icon color="success">mdi-message-text</v-icon>
                        </v-btn>
                      </template>
                      <span v-html="item.A"></span>
                    </v-tooltip>                        
                  </template>
                  -->

                  <template v-slot:[`item.active`]="{ item }">
                    <v-simple-checkbox
                      v-model="item.active"
                      color="info"
                      @click="save2(item.faqId, item.active)"
                    ></v-simple-checkbox>
                  </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      color="warning"
                      class="mr-2"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      color="error"
                      @click="deleteItem(item)"
                    >
                      mdi-delete
                    </v-icon>
                </template>

              </v-data-table>
          </div>
        </v-card>
    </v-form>
  <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
          <v-card-title class="text-h5 mb-3">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5">
              <v-col md="6" cols="12">
                  <p>
                      Questo è l'elenco completo delle FAQ.
                  </p>
                  <p>
                    Ma all'utente vengono visualizzate solo quelle in cui il campo "Attiva" è flaggato.
                  </p>
                  <p>
                    Il campo Ordinamento controlla il modo in cui vengono elencate le FAQ: per far visualizzare al primo posto una certa FAQ, inserire un valore inferiore a quello attualmente più basso.
                  </p>
              </v-col>
              <v-col md="6" cols="12">
                  <p>
                    E' possibile creare nuove FAQ, modificare le esistenti, attivarle, disattivarle ed infine cancellarle                      
                  </p>
                  <p>
                    Con la cancellazione la FAQ viene rimossa definitvamente dall'elenco.
                  </p>
              </v-col>              
              <v-col md="6" cols="12">
                  <p>
                    Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                  </p>
                  <p>
                    Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                  </p>
              </v-col>
              <!--
              <v-col cols="12">
                  <p color="error">
                      <strong>Attenzione:</strong>
                  </p>
              </v-col>
              -->
          </v-row>
      </v-card>
  </v-dialog>    
    <v-dialog v-model="dialog_editItem" max-width="800">
        <v-card>
            <v-card-title class="text-h5">
              Modifica FAQ
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="saveItem('save')">
                      <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                  </template>
                  <span>Conferma</span>
              </v-tooltip>   
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="editedItem={};loading_update=false;dialog_editItem = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 pt-3 mb-0 pb-3">
                <!--<v-col md="3" cols="6" v-for="(d,i) in slots.filter(s=> s!='Giorno')" :key="i">-->
                <v-col cols="12">
                  <v-text-field
                    v-show="false"
                    label="Nome"
                    outlined
                    v-model=editedItem.active
                  >
                  </v-text-field>                  
                  <v-text-field            
                    counter
                    label="Domanda"
                    outlined
                    v-model=editedItem.Q
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                    class="mx-2"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" >
                  <vue-editor id="faq" v-model="editedItem.A" :editorToolbar="customToolbar"  class="mx-2"  />
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    class="mt-2 ml-2"            
                    counter
                    label="Note"
                    outlined
                    v-model=editedItem.R
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    class="mt-2 mr-2"            

                    counter
                    label="Ordinamento"
                    outlined
                    v-model=editedItem.sortOrder
                    persistent-placeholder
                    hide-details
                    reverse
                    type="number"
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                                 
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_delete" max-width="500px">
        <v-card>
            <v-card-title class="text-h5">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Si, Confermo</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>No, Esci</span>
              </v-tooltip>              
            </v-card-title>
        </v-card>
    </v-dialog>         
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { VueEditor  } from "vue2-editor";
//import _ from 'lodash'
export default {
  components: { VueEditor },
  data() {
    return {
      page: "Settings",
      loading:false,
      snackbar_color:null,
      snackbar:false,
      snackbar_message:null,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_editItem:false,
      dialog_delete:false,
      dialog_instruction:false,
      dialog_accomplished_message:'',
      items:[],
      editedItem:{"Q":null,"A":null,"R":null,"sortOrder":null},
      empty_editedItem:{"Q":null,"A":null,"R":null,"sortOrder":null},
      loading_refresh:false,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Domanda',      value: 'Q',          align: 'left',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Risposta',     value: 'A',          align: 'left',    sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'Note',         value: 'remarks',    align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Ord.',         value: 'sortOrder',  align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Attiva',       value: 'active',     align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',    align: 'center',  sortable: false, class:'pl-1 text-lg-button',width:"120" },
              ],      
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        //[{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image"],
      ], 
      items_hash:null    
     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    save2(field,value) {
      console.log(410,value, field);
      var pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_FAQs","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },     
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    }, 
    editItem(f)
    {
      if(f)
        this.editedItem=f;
      console.log(214,f)
      this.dialog_editItem=true;
    },
    /*async saveFAQs()
    {
        console.log(144,this.items);
        this.loading_update=true;
        console.log(255,this.form);
        var action='saveItem';
         let payload={"action":action,"table":"AllFAQs","payload":JSON.stringify(this.items)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editItem=false;
        }   
    },*/
    async saveItem(a)
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        var action='saveItem';
        this.editedItem.A.replace(/<p>/g, '').replace(/<\/p>/g, '');
        var pl=null;
        switch (a)
        {
          case 'delete':
            this.editedItem.deleted=true;
            pl='['+JSON.stringify(this.editedItem)+']';
          break;
          case 'save':
            this.editedItem.active=true;
            pl='['+JSON.stringify(this.editedItem)+']';
          break;
          default:
            pl=this.items;
        }

        let payload={"action":action,"table":"AllFAQS","payload":pl};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.editedItem={...this.empty_editedItem};
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editItem=false;
            this.getData(358);
        }   
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllFAQS_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.allFAQS;
                    this.items_hash=JSON.stringify(this.items)
                    console.log(282,this.items)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        //try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            this.editedItem={...this.empty_editedItem};
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;

              if (res.data.message)
              {
                  console.log(333);
                  this.snackbar_message=res.data.message
                  this.snackbar_color='success';
                  this.snackbar=true;
              }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
              console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        /*} catch(e)
        {
        console.log(e);
        }*/
    },
  },
};
</script>